<template>
    <v-app>
        <customer-type-setup
        :dialog="customerTypeDialog"
        :data="data"
        @update:dialog="customerTypeDialog = $event"
        />
        <v-container fluid>
            <template v-if="$insertAccess($route.fullPath)">
                <v-form @submit.prevent="submit">
                    <v-row>
                        <v-col cols="12">
                            <v-expansion-panels v-model="panel">
                                <v-expansion-panel>
                                    <v-expansion-panel-title
                                        color="blue-grey-lighten-4"
                                        class="panel-header"
                                        ><span>{{
                                        isEntryMode ? "Add Customer Information" : "Update Customer Information"
                                        }}</span></v-expansion-panel-title
                                    >
                                    <v-expansion-panel-text>
                                        <v-row class="py-2 no-gutters justify-space-around">
                                            <v-col lg="4" md="4" cols="12">
                                                <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="company_name.value.value"
                                                :error-messages="company_name.errorMessage.value"
                                                clearable
                                                >
                                            <template #label>
                                                        Customer Company Name
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                            </v-text-field>

                                                <v-text-field
                                                label="Owner Name"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="company_owner_name.value.value"
                                                :error-messages="company_owner_name.errorMessage.value"
                                                clearable
                                                >
                                                </v-text-field>

                                                <v-text-field
                                                label="Email Address"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="company_email.value.value"
                                                :error-messages="company_email.errorMessage.value"
                                                clearable
                                                >
                                                </v-text-field>

                                                <v-text-field
                                                    label="Mobile Number"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="company_mobile.value.value"
                                                    :error-messages="company_mobile.errorMessage.value"
                                                    clearable
                                                >
                                                <template #label>
                                                        Mobile Number
                                                    </template>
                                                </v-text-field>

                                                 <v-text-field
                                                    label="Customer Nature of Business"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="company_business_nature.value.value"
                                                    :error-messages="company_business_nature.errorMessage.value"
                                                    clearable
                                                ></v-text-field>
                                            </v-col>

                                            <v-col lg="4" md="4" cols="12">
                                                <v-autocomplete
                                                    label="Customer Country"
                                                    variant="outlined"
                                                    density="compact"
                                                    bg-color="grey-lighten-4"
                                                    class="px-2"
                                                    v-model="company_country_id.value.value"
                                                    :items="getInvCountryList"
                                                    item-title="name"
                                                    item-value="id"
                                                    :error-messages="company_country_id.errorMessage.value"
                                                    :menu-props="{ width: 300 }"
                                                    autocomplete="off"
                                                    clearable
                                                >
                                                    
                                                    <template v-slot:selection="{ props, item }">
                                                        <div class="d-flex align-center noto-color-emoji-regular"
                                                            v-bind="props"
                                                            color="primary"
                                                            variant="tonal"
                                                        >
                                                        <span class="mr-1">{{ item.raw.emoji }}</span>
                                                        {{ item.raw.name }}
                                                        </div>
                                                    </template>
                                                    <template v-slot:item="{ props, item }">
                                                        <v-list-item v-bind="props" v-slot="" :title="null">
                                                            <div class="d-flex align-center noto-color-emoji-regular" style="width: 100%;">
                                                                <span class="mr-2 text-lg">{{ item.raw.emoji }}</span>
                                                                <div class="flex-grow-1">
                                                                    <span>{{ item.raw.name }}</span>
                                                                    <small v-if="item.raw.native" class="text-grey">
                                                                        ({{ item.raw.native }})
                                                                    </small>
                                                                </div>
                                                                <div class="text-grey text-caption">
                                                                    +{{ item.raw.phonecode }}
                                                                </div>
                                                            </div>
                                                        </v-list-item>
                                                    </template>
                                                </v-autocomplete>

                                                <v-autocomplete
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="company_type_id.value.value"
                                                :error-messages="company_type_id.errorMessage.value"
                                                clearable
                                                :items="getCustomerTypeList"
                                                :item-title="(item) => `${item.code} - ${item.name}`"
                                                autocomplete="off"
                                                item-value="id"
                                                @update:modelValue="getCustomerTypeList"
                                                >
                                                    <template #label>
                                                        Customer Type
                                                        <span class="text-red-accent-4">*</span>
                                                    </template>
                                                    <template v-slot:append-inner>
                                                        <v-slide-x-reverse-transition mode="out-in">
                                                        <v-icon
                                                            @mousedown.stop="openAddCustomerType"
                                                            icon="mdi-plus-circle-outline"
                                                            color="primary"
                                                            size="24"
                                                            class="cursor-pointer"
                                                        ></v-icon>
                                                        </v-slide-x-reverse-transition>
                                                    </template>
                                                </v-autocomplete>

                                                <v-text-field
                                                label="Customer Address"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="company_address.value.value"
                                                :error-messages="company_address.errorMessage.value"
                                                clearable
                                                ></v-text-field>

                                                <v-text-field
                                                label="VAT Number"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="company_vat.value.value"
                                                :error-messages="company_vat.errorMessage.value"
                                                clearable
                                                ></v-text-field>
                                            </v-col>
                                            

                                            <v-col lg="4" md="4" cols="12">

                                                <v-autocomplete
                                                label="Dealing Person"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="dealing_person_id.value.value"
                                                :error-messages="dealing_person_id.errorMessage.value"
                                                clearable
                                                :items="getHrmEmployeeList"
                                                :item-title="(item) => `${item.code} - ${item.name}`"
                                                autocomplete="off"
                                                item-value="id"
                                                ></v-autocomplete>

                                                <v-text-field
                                                label="Customer Website"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="company_website.value.value"
                                                :error-messages="company_website.errorMessage.value"
                                                clearable
                                                ></v-text-field>

                                                <v-text-field
                                                label="BIN No."
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="company_bin.value.value"
                                                :error-messages="company_bin.errorMessage.value"
                                                clearable
                                                >
                                                    <!-- <template #label>
                                                        BIN No.
                                                        <span class="text-red-accent-4">*</span>
                                                    </template> -->
                                                </v-text-field>

                                                

                                                <v-text-field
                                                label="TIN No."
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="company_tin.value.value"
                                                :error-messages="company_tin.errorMessage.value"
                                                clearable
                                                ></v-text-field>

                                            </v-col>
                                        </v-row>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <v-expansion-panels v-model="contactPersonInfo">
                                <v-expansion-panel>
                                    <v-expansion-panel-title
                                        color="blue-grey-lighten-4"
                                        class="panel-header"
                                        ><span>{{
                                        isEntryMode
                                            ? "Add Contact person Information"
                                            : "Update Contact person Information"
                                        }}</span></v-expansion-panel-title
                                    >

                                    <v-expansion-panel-text>
                                        <v-row
                                        v-for="(contact, index) in contacts"
                                        :key="index"
                                        class="px-2 py-2"
                                        align="center"
                                        no-gutters
                                        dense
                                        >
                                            <v-col cols="12" sm="4" md="3" class="pr-4 pa-0">
                                                <v-text-field
                                                v-model="contact.name"
                                                label="Name"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                class="ma-0"
                                                
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="6" sm="4" md="2" class="pr-4 pa-0">
                                                <v-text-field
                                                v-model="contact.mobile"
                                                label="Mobile"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                class="ma-0"
                                               
                                                ></v-text-field>
                                            </v-col>

                                            <v-col cols="6" sm="4" md="2" class="pr-4 pa-0">
                                                <v-text-field
                                                v-model="contact.email"
                                                label="Email"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                class="ma-0"
                                                
                                                />
                                            </v-col>

                                            <v-col cols="6" sm="4" md="2" class="pr-4 pa-0">
                                                <v-text-field
                                                v-model="contact.designation"
                                                label="Designation"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                class="ma-0"
                                                
                                                />
                                            </v-col>

                                            <v-col cols="6" sm="4" md="2" class="pr-4 pa-0">
                                                <v-text-field
                                                v-model="contact.department"
                                                label="Department"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                class="ma-0"
                                                
                                                />
                                            </v-col>

                                            <v-col sm="4" md="1" class="d-flex justify-center mb-5">
                                                <v-btn
                                                @click="removeContactRow(index)"
                                                variant="tonal"
                                                color="primary"
                                                v-if="index !== contacts.length - 1"
                                                >
                                                    <v-icon
                                                        color="red"
                                                        icon="mdi-delete"
                                                        size="large"
                                                    ></v-icon>
                                                </v-btn>

                                                <v-btn
                                                @click="addContactRow"
                                                variant="tonal"
                                                color="primary"
                                                v-else
                                                >
                                                    <v-icon
                                                        color="info"
                                                        icon="mdi-plus"
                                                        size="large"
                                                    ></v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <v-expansion-panels v-model="bankInfo">
                                <v-expansion-panel>
                                    <v-expansion-panel-title
                                        color="blue-grey-lighten-4"
                                        class="panel-header"
                                        ><span>{{
                                        isEntryMode
                                            ? "Add Bank Information"
                                            : "Update Bank Information"
                                        }}</span></v-expansion-panel-title
                                    >

                                    <v-expansion-panel-text>
                                        <v-row
                                        v-for="(info, index) in bank_info"
                                        :key="index"
                                        class="px-2"
                                        no-gutters
                                        dense
                                        >
                                            <v-col class="pr-3" lg="3" md="3" cols="12">

                                                <v-text-field
                                                v-model="info.bank_name"
                                                label="Bank Name"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                hide-details
                                                class="ma-0 py-2"
                                                />
                                                <v-text-field
                                                v-model="info.account_holder_name"
                                                label="Account holder Name"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                hide-details
                                                class="ma-0 py-2"
                                                />
                                            </v-col>
                                            
                                            <v-col class="pr-3" lg="3" md="3" cols="12">
                                                <v-text-field
                                                v-model="info.ac_number"
                                                label="A/C Number"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                hide-details
                                                class="ma-0 py-2"
                                                />
                                                <v-text-field
                                                v-model="info.branch_name"
                                                label="Branch Name"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                hide-details
                                                class="ma-0 py-2"
                                                />
                                            </v-col>

                                            <v-col class="pr-3" lg="3" md="3" cols="12">
                                                <v-text-field
                                                v-model="info.routing_number"
                                                label="Routing Number"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                hide-details
                                                class="ma-0 py-2"
                                                />
                                                <v-text-field
                                                v-model="info.swift_code"
                                                label="Swift Code"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                hide-details
                                                class="ma-0 py-2"
                                                />
                                            </v-col>

                                            <v-col lg="3" md="3" cols="12">

                                                <v-text-field
                                                v-model="info.ifsc_number"
                                                label="IFSC Number"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                hide-details
                                                class="ma-0 py-2"
                                                />

                                                <div class="d-flex justify-end pt-2">
                                                    <v-btn
                                                        @click="removeBankInfoRow(index)"
                                                        variant="tonal"
                                                        color="primary"
                                                        v-if="index !== bank_info.length - 1"
                                                    >
                                                        <v-icon
                                                        color="red"
                                                        icon="mdi-delete"
                                                        size="large"
                                                        ></v-icon>
                                                    </v-btn>
                            
                                                    <v-btn
                                                        @click="addBankInfo"
                                                        variant="tonal"
                                                        color="primary"
                                                        v-else
                                                    >
                                                        <v-icon
                                                        color="info"
                                                        icon="mdi-plus"
                                                        size="large"
                                                        ></v-icon>
                                                    </v-btn>
                                                </div>

                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <v-textarea
                                                clear-icon="mdi-close-circle"
                                                rows="2"
                                                maxlength="500"
                                                label="Description"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="px-2"
                                                v-model="description.value.value"
                                                :error-messages="description.errorMessage.value"
                                                clearable
                                                ></v-textarea>
                                            </v-col>
                    
                                            <v-col>
                                                <v-row>
                                                    <v-col cols="9" class="px-2">
                                                        <v-file-input
                                                            v-model="selectedImage"
                                                            label="Customer Image"
                                                            accept="image/*"
                                                            density="compact"
                                                            single-line
                                                            variant="outlined"
                                                            bg-color="grey-lighten-4"
                                                            show-size
                                                            @input="previewImage"
                                                            @click:clear="clearImage"
                                                            class="ellipsis-filename"
                                                            persistent-hint
                                                            hint="Image must be exactly 120px × 120px"
                                                            prepend-icon="mdi-camera"
                                                            title="image"
                                                        >
                                                        </v-file-input>
                                                    </v-col>
                                                    <v-col cols="3" class="px-2">
                                                        <div class="px-2">
                                                            <v-img :src="preview" cover class="preview-image"></v-img>
                                                        </div>
                                                    </v-col>
                                                    <v-col cols="9" class="px-2">
                                                        <v-file-input
                                                            variant="outlined"
                                                            density="compact"
                                                            label="Customer Document Attachment"
                                                            bg-color="grey-lighten-4"
                                                            class="px-2 py-2"
                                                            v-model="files"
                                                            chips
                                                            show-size
                                                            multiple
                                                        ></v-file-input>
                                                    </v-col>
                                                    <v-col cols="2" class="px-2">
                                                        <v-checkbox label="Active" 
                                                        v-model="status.value.value" 
                                                        :true-value="1" 
                                                        :false-value="0" />
                                                        
                                                     </v-col>
                                                </v-row>
                    
                                            </v-col>
                    
                                        </v-row>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-col>
                    </v-row>

                    <v-card-actions>
                        <v-layout class="justify-end">
                            <v-btn class="bg-brand w-15 ms-2" variant="flat" type="submit">
                                {{ isEntryMode ? "Save" : "Update" }}
                            </v-btn>
                        </v-layout>
                    </v-card-actions>
                </v-form>
            </template>
        </v-container>
    </v-app>
</template>

<script>
import customerTypeSetup from "@/components/module/inventory/customerManagement/customerTypeSetup.vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { useRoute, useRouter } from "vue-router";
import { fileServerUrl } from "@/store/api";
import { reactive } from "vue";

const DEFAULT_IMAGE = "/src/assets/no_preview.jpeg";

export default {
    components: {
        customerTypeSetup,
    },
    data: () => ({
        itemsPerPage: 10,
        panel: [0],
        contactPersonInfo: [0],
        bankInfo: [0],
        loading: false,
        search: "",
        dialog: false,
        customerTypeDialog: false,
        isEntryMode: true,
        unitDialog: false,
        data: {},
        preview: "/src/assets/no_preview.jpeg",
        headers: [
        { title: "#SL", align: "center",key: "index",width: "7%",sortable: false},
        { title: "Code", key: "user_code", align: "left", sortable: false },
        { title: "Name", key: "name", align: "left", sortable: false },
        { title: "Mobile", align: "left", key: "mobile", sortable: true },
        { title: "Email", align: "left", key: "email", sortable: true },
        { title: "Status", align: "center", key: "status", sortable: true },
        { title: "Actions", align: "center", key: "actions", sortable: false },
        ],
    }),
    watch: {},
    created() {
        if (this.$store.getters.getCustomerTypeList.length == 0) {
            this.loading = true;
            this.$store.dispatch("getCustomerTypeList").then((response) => {
            this.loading = false;
            });
        }
        if (this.$store.getters.getInvCountryList.length == 0) {
            this.loading = true;
            this.$store.dispatch("getInvCountryList").then((response) => {
            this.loading = false;
            });
        }
        if (this.$store.getters.getHrmEmployeeList.length == 0) {
            this.loading = true;
            this.$store.dispatch("getHrmEmployeeList", {is_all_branch:true}).then((response) => {
            this.loading = false;
            });
        }
    },
    computed: {
        getInvCountryList() {
            let country = this.$store.getters.getInvCountryList;
            if (country.length > 0) {
                return country;
            }
        },

        getHrmEmployeeList() {
            let employee = this.$store.getters.getHrmEmployeeList;
            if (employee.length > 0) {
                return employee;
            }
        },

        getCustomerTypeList() {
            let data = this.$store.getters.getCustomerTypeList;
            if (data.length > 0) {
                return data.filter((item) => item.status == 1);
            }
            return [];
        },

        editingCustomer() {
            return this.$store.getters.getEditingCustomer;
        },
    },
    methods: {
        openAddCustomerType() {
        this.data = {
            id: "",
            name: "",
            code: "",
            remarks: "",
            status: 1,
        };
        this.customerTypeDialog = true;
        },
        closeDialog() {
            this.dialog = false;
            this.customerTypeDialog = false;
            this.data = {};
        },
        resetForm() {
            this.data = {};
            this.preview = "/src/assets/no_preview.jpeg";
            this.selectedImage = null;
            this.files = [];
        },
        previewImage: function (event) {
            this.selectedImage = event.target.files[0];
            const input = event.target;
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.onload = (e) => {
                this.preview = e.target.result;
                };
                this.image = input.files[0];
                reader.readAsDataURL(input.files[0]);
            } else {
                this.preview = "/src/assets/no_preview.jpeg";
            }
            },
            clearImage() {
            this.preview = "/src/assets/no_preview.jpeg";
        },
    },

    setup() {
        const { handleSubmit, resetForm } = useForm({
        validationSchema: yup.object({
            company_type_id: yup.number().positive().integer().required().label("Customer Type Name"),
            company_name: yup.string().min(1).max(255).required().trim().label("Customer Name"),
        
           
            company_address: yup.string().max(255).nullable().label("Customer Address"),
        }),
        });

        const company_type_id = useField("company_type_id");
        const dealing_person_id = useField("dealing_person_id");
        const company_owner_name = useField("company_owner_name");
        const company_email = useField("company_email");
        const company_name = useField("company_name");
        const company_country_id = useField("company_country_id");
        const company_mobile = useField("company_mobile");
        const company_vat = useField("company_vat");
        const company_bin = useField("company_bin");
        const company_address = useField("company_address");
        const company_website = useField("company_website");
        const company_tin = useField("company_tin");
        const company_business_nature = useField("company_business_nature");
        const description = useField("description");
        const status = useField("status");
        const customer_id = useField("customer_id");
        

        const contacts = ref(
        [
            {
                name: "",
                mobile: "",
                email: "",
                designation: "",
                department: "",
            },
        ]);

        const bank_info = ref(
        [
            {
                bank_name: "",
                account_holder_name: "",
                ac_number: "",
                branch_name: "",
                routing_number: "",
                swift_code: "",
                ifsc_number: "",
            },
        ]);

        const contactErrors = reactive({});
        const errorMessages = ref("");
        const loading = ref("");
        const selectedImage = ref(null);
        const files = ref([]);
        const preview = ref(DEFAULT_IMAGE);

        const isEntryMode = ref(true);

        const store = useStore();
        const router = useRouter();
        const route = useRoute();

        const redirectPath = ref({ path: '/master-data/customer-list' });
        const pathArray = route.fullPath.split('/');
        if (pathArray.includes('sales')) redirectPath.value = { path: '/sales/customer-record' };
        else if(pathArray.includes('master-data')) redirectPath.value = { path: '/master-data/customer-list' };

        const addContactRow = () => {
            contacts.value.push({
                name: "",
                mobile: "",
                email: "",
                designation: "",
                department: "",
            });
        };

        const removeContactRow = (index) => {
        if (contacts.value.length > 1) {
            contacts.value.splice(index, 1);
            delete contactErrors[index];
            const newErrors = {};
            Object.keys(contactErrors).forEach((key) => {
                const idx = parseInt(key);
                if (idx > index) {
                    newErrors[idx - 1] = contactErrors[key];
                } else if (idx < index) {
                    newErrors[idx] = contactErrors[key];
                }
            });
            Object.keys(contactErrors).forEach((key) => delete contactErrors[key]);
            Object.assign(contactErrors, newErrors);
        }
        };

        const addBankInfo = () =>
        ref(
            bank_info.value.push({
            bank_name: "",
            account_holder_name: "",
            ac_number: "",
            branch_name: "",
            routing_number: "",
            swift_code: "",
            ifsc_number: "",
            })
        );

        const removeBankInfoRow = (index) => {
        if (bank_info.value.length > 1) {
            bank_info.value.splice(index, 1);
        }
        };

        const submit = handleSubmit((values) => {

            const contactsData = contacts.value || [];
            const bankInfoData = bank_info.value || [];

            const formData = new FormData();

            Object.keys(values).forEach((key) => {
                if (values[key] !== undefined && values[key] !== null) {
                    formData.append(key, values[key]);
                }else{
                    formData.append(key,'');
                }
            }); 

            formData.append("contacts",  JSON.stringify(contactsData));
            formData.append("bank_info", JSON.stringify(bankInfoData));

            if (selectedImage.value) {
                formData.append("image", selectedImage.value);
            }

            if (files.value) {
                formData.append("files", files.value);
            }

            store.dispatch("saveUpdateCustomer", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }).then((response) => {
                resetForm();
                loading.value = false;
                toast.success(response.data.message,{
                  timeout: 3000,
                });
                setTimeout(() => {
                    router.push(redirectPath.value);
                }, 1000);
                
            })
            .catch((error) => {
                loading.value = false;
                if (error.response && error.response.data) {
                    const { message, errors } = error.response.data;
                    if (errors) {
                        const errorMessages = Object.values(errors).flat() .join('\n');
                        toast.error(`${message}\n${errorMessages}`);
                    } else {
                        toast.error(message || 'Something went wrong.');
                    }
                } else {
                    toast.error('Server error. Please try again.');
                }
                // toast.error(error.response.data.message);
            });
        });
        return {
            submit,
            company_type_id,
            dealing_person_id,
            company_owner_name,
            company_email,
            company_name,
            company_mobile,
            company_address,
            company_website,
            company_vat,
            company_country_id,
            company_tin,
            company_bin,
            company_business_nature,
            description,
            contacts,
            bank_info,
            status,
            addContactRow,
            removeContactRow,
            contactErrors,
            addBankInfo,
            removeBankInfoRow,
            errorMessages,
            selectedImage,
            files,
            preview,
            isEntryMode,
            customer_id,
            resetForm,
            loading,
        };
    },
    mounted() {
        if (this.$store.getters.getEditingCustomer) {
            this.isEntryMode = false;
            const customer = this.$store.getters.getEditingCustomer;
            console.log(customer)
            this.customer_id.value.value = customer.id;
            this.company_owner_name.value.value = customer.company_owner_name;
            this.company_email.value.value = customer.company_email;
            this.company_name.value.value = customer.company_name;
            this.company_mobile.value.value = customer.company_mobile;
            this.dealing_person_id.value.value = customer.dealing_person_id;
            this.company_vat.value.value = customer.company_vat;
            this.company_bin.value.value = customer.company_bin;
            this.company_tin.value.value = customer.company_tin;
            this.company_business_nature.value.value = customer.company_business_nature;
            this.company_address.value.value = customer.company_address;
            this.company_website.value.value = customer.company_website;
            this.company_type_id.value.value = customer.company_type_id;
            this.company_country_id.value.value = customer.company_country_id;
            this.description.value.value = customer.description;
            this.status.value.value = customer.status;  
            this.contacts = customer.contacts || [
                {
                    name: "",
                    mobile: "",
                    email: "",
                    designation: "",
                    department: "",
                },
            ];
            this.bank_info = customer.bank_info || [
                {
                    bank_name: "",
                    account_holder_name: "",
                    ac_number: "",
                    branch_name: "",
                    routing_number: "",
                    swift_code: "",
                    ifsc_number: "",
                },
            ];
            // this.status.value.value = customer.status == 1 ? true : false;
            if (customer.image) {
                this.preview = customer.image
                ? fileServerUrl + customer.image
                : "/src/assets/no_preview.png";
            } else {
                this.preview = DEFAULT_IMAGE;
            }
        } else {
            this.status.value.value = 1;
            this.customer_id.value.value = "";
            this.isEntryMode = true;
        }
    },

    beforeUnmount() {
        // Clear the editing customer from Vuex when component is destroyed
        this.$store.commit('clearEditingCustomer');
      }
};
</script>
